import React, { useContext, useEffect } from 'react'

// @mui core components
import { Box, Grid, Typography, Button } from '@mui/material'
import Card from 'atoms/Card'

// Settings page components
import FormField from 'components/FormField'

// Data
import { IntakeContext } from 'context/IntakeContext'
import { selectData } from 'layouts/onboarding'

// Popup
import { toast } from 'react-toastify'
import { renderMuiFormField } from 'utils/forms/renderMuiFormField'

import { useState } from 'react'

// Debounce
import { useFormDebounce } from 'hooks/useFormDebounce'
import LoadingButton from 'components/LoadingButton'

import { format, subYears, differenceInYears } from 'date-fns'
import FamilyDependents from 'admin/components/FamilyDependents'

function Family() {
  const { intakeState, updateIntakeStateAtKey, updateUser } =
    useContext(IntakeContext)

  const { updateIntakeStateAndSubmit, loading } = useFormDebounce()

  const [ageQuestion, setAgeQuestion] = useState(true)

  const dateToYears = (date) =>
    differenceInYears(new Date(), new Date(date || new Date()))
  const yearsToDate = (years) =>
    format(subYears(new Date(), years), 'yyyy-MM-dd')

  // add an onSubmit button and call the context function `updateUser`
  // const onSubmit = () => updateUser()
  const onSubmit = async () => {
    await updateUser()
    toast.info('You have successfully updated your family details', {
      position: 'top-center',
      autoClose: 5000,
      pauseOnFocusLoss: false,
      pauseOnHover: false,
    })
  }

  const [localForm, setLocalForm] = useState({
    familySpouseFirstName: intakeState.familySpouseFirstName || '',
    familySpouseLastName: intakeState.familySpouseLastName || '',
    familySpousePhone: intakeState.familySpousePhone || '',
    familySpouseDateOfBirth: intakeState.familySpouseDateOfBirth || '',
    familySpouseAge: dateToYears(intakeState?.familySpouseDateOfBirth) || '',
    familyDivorcedMarriageStartDate:
      intakeState.familyDivorcedMarriageStartDate || '',
    familyDivorcedMarriageEndDate:
      intakeState.familyDivorcedMarriageEndDate || '',
    familyChildren: intakeState.familyChildren || '',
  })
  const handleChange = (field) => (value) => {
    setLocalForm((prev) => ({ ...prev, [field]: value }))
  }

  const maritalStatus = intakeState?.familyMaritalStatus
  const divorcedStatus = intakeState?.familyDivorced
  const divorcedOwed = intakeState?.familyDivorcedOwedPension
  const isGovernmentEmployee = intakeState?.governmentEmployee
  useEffect(() => {
    // console.log(intakeState)
  }, [intakeState])

  return (
    <>
      <Box
        pl={3}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Typography display="flex" align="left" variant="body2FunHeader">
          FAMILY
        </Typography>

        <LoadingButton loading={loading} onClick={onSubmit} />
      </Box>
      <Card>
        <Box component="form" p={3}>
          <Grid container columnSpacing={3} rowSpacing={2}>
            <Grid item xs={12} sm={6}>
              {renderMuiFormField({
                autoFocus: false,
                id: 'familyMaritalStatus',
                label: 'What is your current Marital Status?',
                placeholder: intakeState.familyMaritalStatus,
                inputType: 'select',
                value: intakeState.familyMaritalStatus,
                onChange: updateIntakeStateAndSubmit((familyMaritalStatus) =>
                  updateIntakeStateAtKey({
                    familyMaritalStatus: familyMaritalStatus,
                    familyDivorced:
                      familyMaritalStatus === 'divorced' ? true : false,
                  })
                ),
                options: selectData.relationshipStatus,
              })}
            </Grid>

            {maritalStatus === 'married' && (
              <>
                <Grid item xs={0} sm={6}></Grid>
                <Grid item xs={12} sm={4}>
                  {renderMuiFormField({
                    id: 'familySpouseFirstName',
                    label: "Spouse's First Name",
                    placeholder: "Spouse's First Name",
                    inputType: 'text',
                    value: localForm.familySpouseFirstName,
                    onChange: (e) => handleChange('familySpouseFirstName')(e),
                    onBlur: updateIntakeStateAndSubmit(
                      (familySpouseFirstName) =>
                        updateIntakeStateAtKey({
                          familySpouseFirstName,
                        })
                    ),
                  })}
                </Grid>
                <Grid item xs={12} sm={4}>
                  {renderMuiFormField({
                    id: 'familySpouseLastName',
                    label: "Spouse's Last Name",
                    placeholder: "Spouse's Last Name",
                    inputType: 'text',
                    value: localForm.familySpouseLastName,
                    onChange: (e) => handleChange('familySpouseLastName')(e),
                    onBlur: updateIntakeStateAndSubmit((familySpouseLastName) =>
                      updateIntakeStateAtKey({
                        familySpouseLastName,
                      })
                    ),
                  })}
                </Grid>
                <Grid item xs={12} sm={4}>
                  {renderMuiFormField({
                    id: 'familySpousePhone',
                    label: "Spouse's Phone #",
                    placeholder: "Spouse's #",
                    inputType: 'tel',
                    value: localForm.familySpousePhone,
                    onChange: (e) => handleChange('familySpousePhone')(e),
                    onBlur: updateIntakeStateAndSubmit((familySpousePhone) =>
                      updateIntakeStateAtKey({
                        familySpousePhone,
                      })
                    ),
                  })}
                </Grid>

                {ageQuestion ? (
                  <>
                    <Grid item xs={12} sm={6}>
                      <Grid item xs={12}>
                        {renderMuiFormField({
                          id: 'familySpouseDateOfBirth',
                          label: `Spouse's Date of Birth`,
                          inputType: 'date',
                          defaultDate: '1970-01-01',
                          dateListTrim: { start: 0, end: 80 },
                          value: localForm.familySpouseDateOfBirth,
                          onChange: (e) => {
                            handleChange('familySpouseDateOfBirth')(e)
                            handleChange('familySpouseAge')(dateToYears(e))
                          },
                          onBlur: updateIntakeStateAndSubmit(
                            (familySpouseDateOfBirth) =>
                              updateIntakeStateAtKey({
                                familySpouseDateOfBirth,
                              })
                          ),
                        })}
                      </Grid>

                      <Box display="flex" justifyContent="flex-start">
                        <Button
                          variant="text"
                          color="info"
                          sx={{ height: '100%' }}
                          onClick={() => setAgeQuestion(false)}
                        >
                          Use their age instead
                        </Button>
                      </Box>
                    </Grid>
                  </>
                ) : (
                  <>
                    <Grid item xs={12} sm={6}>
                      <Grid item xs={12}>
                        {renderMuiFormField({
                          id: 'familySpouseAge',
                          label: `Spouse's Age`,
                          inputType: 'int',
                          placeholder: 'e.g. 62',
                          value: localForm.familySpouseAge,
                          onChange: (e) => {
                            handleChange('familySpouseAge')(e)
                            handleChange('familySpouseDateOfBirth')(
                              yearsToDate(e)
                            )
                          },
                          onBlur: updateIntakeStateAndSubmit(
                            (familySpouseDateOfBirth) =>
                              updateIntakeStateAtKey({
                                familySpouseDateOfBirth: yearsToDate(
                                  familySpouseDateOfBirth
                                ),
                              })
                          ),
                        })}
                      </Grid>

                      <Box display="flex" justifyContent="flex-start">
                        <Button
                          variant="text"
                          color="info"
                          sx={{ height: '100%' }}
                          onClick={() => setAgeQuestion(true)}
                        >
                          Use their date of birth instead
                        </Button>
                      </Box>
                    </Grid>
                  </>
                )}
              </>
            )}

            <Grid item xs={12} sm={6}>
              {renderMuiFormField({
                autoFocus: false,
                id: 'familyDivorced',
                label: 'Have you ever been divorced?',
                placeholder: intakeState.familyDivorced,
                inputType: 'select',
                value: intakeState.familyDivorced,
                onChange: updateIntakeStateAndSubmit((familyDivorced) =>
                  updateIntakeStateAtKey({ familyDivorced })
                ),
                options: selectData.yesNo,
              })}
            </Grid>

            {divorcedStatus && (
              <>
                {isGovernmentEmployee && <Grid item xs={12} sm={6}>
                  {renderMuiFormField({
                    autoFocus: false,
                    id: 'familyDivorcedOwedPension',
                    label:
                      'Will your former spouse be owed any of your pension?',
                    placeholder: intakeState.familyDivorcedOwedPension,
                    inputType: 'select',
                    value: intakeState.familyDivorcedOwedPension,
                    onChange: updateIntakeStateAndSubmit(
                      (familyDivorcedOwedPension) =>
                        updateIntakeStateAtKey({ familyDivorcedOwedPension })
                    ),
                    options: selectData.yesNo,
                  })}
                </Grid>}

                {divorcedOwed && (
                  <Grid item xs={12} sm={6}>
                    <Grid container columnSpacing={3} rowSpacing={2} pt={1}>
                      <Grid item xs={12} sm={6}>
                        {renderMuiFormField({
                          id: 'familyDivorcedMarriageStartDate',
                          label: 'Marriage date with former spouse',
                          inputType: 'date',
                          defaultDate: '1970-01-01',
                          dateListTrim: { start: 0, end: 80 },
                          value: localForm.familyDivorcedMarriageStartDate,
                          onChange: (e) =>
                            handleChange('familyDivorcedMarriageStartDate')(e),
                          onBlur: updateIntakeStateAndSubmit(
                            (familyDivorcedMarriageStartDate) =>
                              updateIntakeStateAtKey({
                                familyDivorcedMarriageStartDate,
                              })
                          ),
                        })}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        {renderMuiFormField({
                          id: 'familyDivorcedMarriageEndDate',
                          label: 'Divorce date with former spouse',
                          inputType: 'date',
                          defaultDate: '1970-01-01',
                          dateListTrim: { start: 0, end: 80 },
                          value: localForm.familyDivorcedMarriageEndDate,
                          onChange: (e) =>
                            handleChange('familyDivorcedMarriageEndDate')(e),
                          onBlur: updateIntakeStateAndSubmit(
                            (familyDivorcedMarriageEndDate) =>
                              updateIntakeStateAtKey({
                                familyDivorcedMarriageEndDate,
                              })
                          ),
                        })}
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              </>
            )}
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={6}>
                  {renderMuiFormField({
                    autoFocus: false,
                    id: 'familyChildren',
                    label: 'Number of children (if any)',
                    placeholder: intakeState.familyChildren,
                    inputType: 'int',
                    maxValue: 12,
                    value: localForm.familyChildren,
                    onChange: (e) => handleChange('familyChildren')(e),
                    onBlur: updateIntakeStateAndSubmit((familyChildren) =>
                      updateIntakeStateAtKey({ familyChildren })
                    ),
                  })}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12}>
              <FamilyDependents
                numDependents={intakeState?.familyChildren || 0}
                initialDependents={intakeState?.familyDependents || []}
                updateIntakeStateAndSubmit={updateIntakeStateAndSubmit}
                updateIntakeStateAtKey={updateIntakeStateAtKey}
              />
            </Grid>
          </Grid>
        </Box>
      </Card>
    </>
  )
}

export default React.memo(Family)
